import { render, staticRenderFns } from "./BtnCard.vue?vue&type=template&id=631b7166&"
import script from "./BtnCard.vue?vue&type=script&lang=js&"
export * from "./BtnCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports